<template>
  <div class="pa-2">
    <span class="heading mb-2">Project Page</span>
     <v-btn
      depressed
      @click="showProjectBox"
      color="primary"
    >
      Create Project
    </v-btn>

    <v-data-table :headers="headers" :items="projectList"
    
    :expanded.sync="expanded"
    :single-expand="singleExpand"
     item-key="uuid"
    class="elevation-1"
    show-expand
    @click:row="rowProjectHandler"
     >
     <template v-slot:item.actions="{ item }">
      <v-btn small class="mr-4" v-on:click="inviteHandler(item)"
        >Invite User</v-btn
      >
      <v-btn small class="mr-4" v-on:click="handleSchedule(item)"
        >Create Schedule</v-btn
      >
     
    </template>

   <template v-slot:expanded-item="{ headers, item ,expand, isExpanded }">
     
      <td :colspan="headers.length">
        <v-data-table
          class="sub-table elevation-0"
          :headers="scheduleHeaders"
          :items="item.scheduleList"
          item-key="name"
          @click:row="handleClick"
          hide-default-footer
          
        >
       
        </v-data-table>
      </td>
    </template>
    </v-data-table>

    <v-dialog
      v-model="projectDialog"
      width="500"
        height="100%"
    >
    <v-card>
      <v-form
      style="padding:5px"
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="name"
      :counter="10"
      label="Name"
    ></v-text-field>

    <v-text-field
      v-model="add_line_1"
      label="Address One"
    ></v-text-field>
     <v-text-field
      v-model="city"
      label="City"
    ></v-text-field>
    
    <v-select
          :items="stateList"
          v-model="state"
          label="State"
          solo
        ></v-select>
<v-text-field
      v-model="zip"
      label="Zip"
    ></v-text-field>
    <v-text-field
      v-model="latitude"
      label="latitude"
    ></v-text-field>
    <v-text-field
      v-model="longitude"
      label="longitude"
    ></v-text-field>
    
    

    <v-btn
      color="success"
      class="mr-4"
      @click="companyProjectHandle"
    >
      Add Project
    </v-btn>

   
  </v-form>
    </v-card>
    </v-dialog>



 <v-dialog
      v-model="itemDialog"
      width="500"
        height="100%"
    >
    <v-card>
      <v-form
      style="padding:5px"
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="item.mark"
      :counter="10"
      label="Mark"
    ></v-text-field>

    <v-text-field
      v-model="item.alias"
      label="Alias"
    ></v-text-field>
     <v-text-field
      v-model="item.room_name"
      label="Room Name"
      
    ></v-text-field>
     <v-text-field
      v-model="item.product_type"
      label="Product Type"
    ></v-text-field>
    
     <v-text-field
      v-model="item.series_name"
      label="Series Name"
    ></v-text-field>

    <v-select
         
        
          dense
         
          v-model="item.rvt_level_id"
          :items="scheduleLevels"
          :item-text="(item) => item.name"
          item-value="item.rvt_level_id"
          filled
          label="Select Level"
          return-object
          
        ></v-select>
    
<v-text-field
      v-model="item.type_name"
      label="Type Name"
    ></v-text-field>
    <v-text-field
      v-model="item.model_id"
      label="Model Id"
    ></v-text-field>

    <v-text-field
      v-model="item.glass.glass_type"
      label="Glass Type"
    ></v-text-field>
    <v-text-field
      v-model="item.glass.glass_tint"
      label="Glass Tint"
    ></v-text-field>
    <v-text-field
      v-model="item.glass.glass_patten"
      label="Glass Patten"
    ></v-text-field>
    <v-text-field
      v-model="item.glass.glass_thickness"
      label="Glass Thickness"
    ></v-text-field>
    <v-text-field
      v-model="item.glass.installation_elevation"
      label="Elevation"
    ></v-text-field>
    <v-text-field
      v-model="item.glass.min_thickness"
      label="Min Thickness"
    ></v-text-field>

    <v-text-field
      v-model="addons.name"
      label="Addon Name"
    ></v-text-field>
    <v-text-field
      v-model="addons.option_name"
      label="Option Name"
    ></v-text-field>


     <v-text-field
      v-model="item.grid.pattern"
      label="Grid Pattern"
    ></v-text-field>
    <v-text-field
      v-model="item.grid.color"
      label="Grid Color"
    ></v-text-field> <v-text-field
      v-model="item.grid.size"
      label="Grid Size"
    ></v-text-field>
    <v-text-field
      v-model="item.grid.type"
      label="Grid Type"
    ></v-text-field>


    <v-text-field
      v-model="item.color.exterior_color"
      label="Exterior Color"
    ></v-text-field>
    <v-text-field
      v-model="item.color.interior_color"
      label="Interior Color"
    ></v-text-field> <v-text-field
      v-model="item.color.painted_interior_color"
      label="Painted Interior Color"
    ></v-text-field>
    <v-text-field
      v-model="item.color.painted_exterior_color"
      label="Painted Exterior Color"
    ></v-text-field>


     <v-text-field
      v-model="item.size.height"
      label="Size Height"
    ></v-text-field> <v-text-field
      v-model="item.size.width"
      label="Size Width"
    ></v-text-field>
    <v-text-field
      v-model="item.size.sill_height"
      label="Sill Height"
    ></v-text-field>

    <v-text-field
      v-model="item.rough_opening.height"
      label="Opening Height"
    ></v-text-field>
    <v-text-field
      v-model="item.rough_opening.width"
      label="Opening Width"
    ></v-text-field>

    <v-text-field
      v-model="item.frame.type_name"
      label="Frame Name"
    ></v-text-field>
    
    

    <v-btn
      color="success"
      class="mr-4"
      @click="createItem"
    >
      Add Item
    </v-btn>

   
  </v-form>
    </v-card>
    </v-dialog>



     <v-dialog
      v-model="createDialog"
      width="500"
        height="100%"
    >
    <v-card>
      <v-form
      style="padding:5px"
    ref="form"
    v-model="valid"
    lazy-validation
  >
    <v-text-field
      v-model="scheduleName"
      :counter="10"
      label="Name"
    ></v-text-field>

    

    <v-btn
      color="success"
      class="mr-4"
      @click="createSchedule"
    >
      Create Schedule
    </v-btn>

   
  </v-form>
    </v-card>
    </v-dialog>




     <v-dialog
      v-model="inviteDialog"
      width="500"
        height="100%"
    >
    <v-card>
      <v-form
      style="padding:5px"
    ref="form"
    v-model="isinvite"
    lazy-validation
  >
   
    <v-text-field
      v-model="inviteEmail"
      :counter="10"
      label="Email"
    ></v-text-field>

   

    <v-btn
      color="success"
      class="mr-4"
      @click="inviteHandle"
    >
      Send Invite
    </v-btn>

   
  </v-form>
    </v-card>
    </v-dialog>
<!-- create Version -->
    <v-dialog
      v-model="versionDialog"
      width="500"
        height="100%"
    >
    <v-card>
      <v-form
      style="padding:5px"
    ref="form"
    v-model="isinvite"
    lazy-validation
  >
   
    <v-text-field
      v-model="versionNumber"
      label="Version Number"
    ></v-text-field>

   

    <v-btn
      color="success"
      class="mr-4"
      @click="createVersion"
    >
      add version
    </v-btn>

   
  </v-form>
    </v-card>
    </v-dialog>
    

    <v-dialog
      v-model="scheduleDialog"
      width="600"
        height="100%"
    >
     <v-card style="width:600px">
       
<v-row style="padding:10px">
         <v-select
         class="col-md-3"
         style="margin-left:10px"
          dense
         
          v-model="selectedVersion"
          :items="itemVersions"
          :item-text="(item) => item.number"
          item-value="number"
          filled
          label="Select Version"
          return-object
          @change="
            getScheduleItemVersion()
          "
        ></v-select>
        <v-btn
         style="margin-left: 50px;
    margin-top: 10px;"
      color="success"
      class="col-md-3"
      @click="versionHandle"
    >
      Create Version
    </v-btn>
        <v-btn
         style="margin-left: 10px;
    margin-top: 10px;"
      color="success"
      class="col-md-3"
      @click="itemHandle"
    >
      Create Item
    </v-btn>
    
</v-row>
       <!-- </div> -->
    <v-data-table
          :headers="scheduleItemHeaders"
          :items="scheduleItems"
          
        >
    </v-data-table>
     </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { projectApi ,scheduleApi} from "@/api";
import { mapActions } from "vuex";

export default {
  components: {

  },
  data() {
    return {
      expanded:[],
      singleExpand: true,
      stateList:[
        
  "Alabama",
  "Alaska",
  "American Samoa",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "District Of Columbia",
  "Federated States Of Micronesia",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Marshall Islands",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Northern Mariana Islands",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Palau",
  "Pennsylvania",
  "Puerto Rico",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virgin Islands",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming"

      ],
      projectDialog: false,
      inviteDialog:false,
      valid: true,
      isinvite:true,
      scheduleDialog:false,
      selectedProject:null,
      versionDialog:false,
      inviteEmail:"",
     name:'',
     add_line_1:'',
     add_line_2:'',
     city:'',
     state:'',
     zip:'',
     latitude:'',
     longitude:'',
     createDialog:false,
     projectList:[],
     selectedUUID:null,
     itemDialog:false,
     versionNumber:null,
     headers: [
          { text: 'Name', value: 'name' },
           { text: 'Owner', value: 'owner' },
           { text: 'Created', value: 'created_on' },
           { text: 'Owner', value: 'owner' },
           { text: 'Address', value: 'address.address_line_1' },
            { text: "Actions", value: "actions", sortable: false },
            { text: '', value: 'data-table-expand' }
        ],
     scheduleHeaders: [
          {
            text: 'Schedule',
            value: 'name',
            width:300
          },
          { text: 'Status', value: 'status' , width:300},
        ],
        scheduleItemHeaders: [
          {
            text: 'Product Name',
            value: 'product_name'
          },
          { text: 'Room Name', value: 'room_name'},
          { text: 'Level Name', value: 'level_name'},
          { text: 'Exterior Color', value: 'color.exterior_color'},
          { text: 'Interior Color', value: 'color.interior_color'},
        ],
        scheduleItems:[],
        selectedVersion:null,
        scheduleName:null,
        itemVersions:[],
        scheduleLevels:[],
        scheduleName:'',
        selectedProjectId:null,
        item: {
        mark: "",
        alias: "",
        rvt_level_id: "",
        room_name: "",
        product_type: "window",
        series_name: "",
        type_name: "",
        model_id: "",
        testing_results: {
            AAMA: null,
            STC: null,
            NFRC: null
        },
        glass: {
            glass_type: "",
            glass_tint: "",
            glass_patten: "",
            glass_thickness: "",
            installation_elevation: "",
            min_thickness: "",
            addons: [
                {
                    name: "",
                    option_name: ""
                }
            ]
        },
        grid: {
            pattern: "",
            color: "",
            size: "",
            type: ""
        },
        color: {
            exterior_color: "",
            interior_color: "",
            painted_interior_color: "",
            painted_exterior_color: ""
        },
        size: {
            height: "",
            width: "",
            sill_height: ""
        },
        rough_opening: {
            height: "",
            width: ""
        },
        frame: {
            type_name: ""
        }
    },
    addons:{
      name:"",
      option_name:""
    }

     
    };
  },
  computed: {
      
  },
  created() {
 this.loadProjectData();
  },
  methods: {
     ...mapActions(["toggleCollaboratorsModal"]),
    showProjectBox(){
     this.projectDialog=true;
   },
   handleSchedule(item){
     this.createDialog=true;
     this.selectedProjectId=item.uuid;
   },
   versionHandle()
   {
     this.versionDialog=true;
   },
   async createVersion()
   {
     let params={
         project_id:this.selectedUUID,
         scheduleName:this.scheduleName,
         version:parseInt(this.versionNumber),
         RFQ:{
          RFQ_id:null
          }
     }
     try{
   const versionCreat=await scheduleApi.createScheduleVersion(params);
  console.log("version",versionCreat);
         if(versionCreat.status==200)
          {
            this.$toast.success("Version created successfully.");
          }
          else
          {
             this.$toast.error("Version already exist");
          }
     }catch(e)
     {
       
        this.$toast.error("Version already exist");
     }
 
   },
   
   getScheduleItemVersion(){

let params={
         project_id:this.selectedUUID,
         scheduleName:this.scheduleName,
         version:this.selectedVersion.number,
         query:{
           page:1,
           size:10
         }
       }
        let loader = this.$loading.show();
      scheduleApi.getScheduleItems(params).then((response)=>{
         scheduleApi.getScheduleLevels(params).then((resp)=>{
        loader.hide();
        this.scheduleLevels=resp.data;
         });
         this.scheduleItems=response.data.items;
       })
   },
   rowProjectHandler(item, event) {
      this.selectedUUID=item.uuid;
      this.expanded=[];
      this.expanded.push(item);
    },
   handleClick(value){
    this.itemVersions=value.versions;
    this.scheduleName=value.name;
     let params={
         project_id:this.selectedUUID,
         scheduleName:value.name,
         version:value.versions[value.versions.length-1].number,
         query:{
           page:1,
           size:10
         }
       }
        
      scheduleApi.getScheduleItems(params).then((response)=>{
         
         this.scheduleItems=response.data.items;
         scheduleApi.getScheduleLevels(params).then((resp)=>{
        console.log("=====SChedule LEVELS",resp);
        this.scheduleLevels=resp.data;
       
         })
          this.scheduleDialog=true;
       })
   },
    loadProjectData(){
      let loader = this.$loading.show();
      projectApi
      .getProject({
        page: 1,
        size: 100,
      })
      .then(({ data }) => {
       loader.hide();
       this.projectList=data.project;
       console.log("Project Data",data.project);
       for(let i=0;i<data.project.length;i++)
       {
        let params={
         project_id:data.project[i].uuid,
         page:1,
         size:10
       }
       scheduleApi.getSchedules(params).then((response)=>{
         this.projectList[i].scheduleList=response.data.schedule;
       })
       }
       console.log("======SCHEDULE DATA",this.projectList);
      });
     
    },
    inviteHandler(data) {
      this.selectedProject=data.name;
      this.inviteDialog=true;
    },
   async createSchedule(item){
      try{
        if(this.scheduleName==null ||this.scheduleName==undefined || this.scheduleName=='')
          {
          this.$toast.error("invalid schedule name");
          }
          else{
             let loader = this.$loading.show();
             let scheduleParams={
               schedule_name:this.scheduleName,
               project_id:this.selectedProjectId
             }
             const addSchedule = await scheduleApi.createSchedule({
            ...scheduleParams
          });
          if(addSchedule.status==201)
          {
            this.$toast.success("Schedule created successfully.");
          }
          else
          {
             this.$toast.error("unable to create schedule");
          }
          loader.hide();
          }
      }catch(e)
      {

      }
    },
    itemHandle()
    {
      this.itemDialog=true;

    },
    async createItem()
    {
       let loader = this.$loading.show();
      this.item.rvt_level_id=this.item.rvt_level_id.client_level_id;
      this.item.glass.addons=[];
      this.item.glass.addons.push(this.addons);
      let payload={
        body:{
          item:this.item,
          config_id:null
        },
         project_id:this.selectedUUID,
         scheduleName:this.scheduleName,
         version:this.selectedVersion.number,
      }
       const addScheduleItem = await scheduleApi.createScheduleItem({
            ...payload
          });
       if(addScheduleItem.status==201 || addScheduleItem.status==200)
          {
            this.$toast.success("Schedule created successfully.");
          }
          else
          {
             this.$toast.error("unable to create schedule item");
          }
            loader.hide();
      
    },

    async companyProjectHandle() {
     
        try {
          if(this.name==null ||this.name==undefined || this.name=='')
          {
          this.$toast.error("invalid project name");
          }
          else if(this.zip==null || this.zip==undefined||this.zip=='')
        {
          this.$toast.error("invalid zip");
        }
        else{
          let loader = this.$loading.show();
 let projectDetails={
                "name":this.name,
                 "address":{
                 "address_line_1":this.add_line_1,
                "address_line_2":this.add_line_2,
                "city":this.city,
                 "state":this.state,
                 "zip":this.zip,
                 "latitude":this.latitude,
                 "longitude":this.longitude
                 }
            } 
          const addProject = await projectApi.createProject({
            ...projectDetails
          });
          loader.hide();
         
          this.$toast.success("Project is created successfully.");
          this.loadProjectData();
          this.projectDialog=false;
        }
           
        } catch (error) {
          loader.hide();
          this.$toast.error(error.response.data.message);
        }
      
    },
  async inviteHandle() {
     
        let loader = this.$loading.show();
        try {
            let inviteDetails={
              "email":this.inviteEmail,
              "projectName":this.selectedProject
            } 
          const inviteDealer = await projectApi.inviteUser({
            ...inviteDetails
          });
          loader.hide();
          if(inviteDealer.status==201)
          {
this.$toast.success("Invite sent successfully");
          }
          else{
             this.$toast.error(inviteDealer.data.message);
          }
        this.inviteDialog=false;
          
        } catch (error) {
          loader.hide();
          this.$toast.error(error.response.data.message);
        }
      
    },
    
    
    handleProjectCreateBtnClick() {
      this.createProject.dialog = true;
    },
   
    

  },
};
</script>

<style>
.heading {
  font-size: 18pt;
  display: block;
}

.modal-lg {
    max-width: 1000px !important;
    width:1000px !important;
   }


  .modal-dialog {
    max-width: 1000px !important;
width:1000px !important;
  }

</style>
